<div class="total">{{text()}}</div>
